import styled from 'styled-components';

export const StyledFooter = styled.div`
  background: ${props => props.theme.themeColors.footer.background};
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px 60px 16px;
  transition: background-color ${({ theme }) => theme.backgroundTransitionTime}
    ease;

  & span {
    color: ${props => props.theme.themeColors.footer.textColor};
  }
  @media all and (max-width: 1200px) {
    padding: 20px 20px 20px;
  }
`;

export const LowerWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
  width: 100%;
`;
